import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 170.62 167.72",
	width: "100%",
	height: "100%",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M70.43,98.99c1.71-1.96,3.35-3.84,4.99-5.73,7.4-8.5,14.8-17,22.21-25.5,5.15-5.91,10.3-11.83,15.46-17.73.81-.92,1.68-1.8,2.56-2.65,1.8-1.73,3.51-1.79,5.57-.23,1.86,1.41,2.39,3.53,1.24,5.51-1.02,1.75-2.14,3.45-3.26,5.14-12.79,19.27-25.6,38.54-38.4,57.82-1.3,1.95-2.88,3.59-4.93,4.75-3.66,2.09-7.56,1.71-10.54-1.26-1.55-1.54-2.89-3.32-4.17-5.11-5.87-8.27-11.68-16.58-17.51-24.88-.91-1.3-1.37-2.71-1.05-4.32.5-2.58,4.32-5.05,7.35-2.81,1.69,1.25,3.27,2.64,4.89,3.99,4.86,4.06,9.72,8.14,14.58,12.2.31.26.63.49,1.02.8Z"
	})
});
export default SvgCheckmark;
